import { commonBase } from '@kid/meta-color/color/output/all';
import { useRem } from '../../hooks/useRem';
import { useStyle } from '../../hooks/useStyle';
export function useProgressStyle(props) {
    const rem = useRem(props.isScalable);
    const { color = commonBase.kiui_color_base_red_1, trackColor = commonBase.kiui_color_base_black_16, percentage = 0, strokeWidth = 4, pivotColor = commonBase.kiui_color_base_white_1, pivotBgColor = null, } = props || {};
    const style = useStyle({
        activeBar: {
            backgroundColor: color,
            height: rem(strokeWidth),
            flex: percentage,
            borderTopLeftRadius: rem(strokeWidth / 2),
            borderBottomLeftRadius: rem(strokeWidth / 2),
        },
        pivotNode: {
            backgroundColor: pivotBgColor || color,
            color: pivotColor,
            borderRadius: rem(12),
            fontSize: rem(12),
            paddingHorizontal: rem(6),
            paddingVertical: rem(1),
        },
        inactiveBar: {
            backgroundColor: trackColor,
            height: strokeWidth,
            flex: 100 - percentage,
            borderTopRightRadius: strokeWidth / 2,
            borderBottomRightRadius: strokeWidth / 2,
        },
    });
    return {
        style,
    };
}
